// extracted by mini-css-extract-plugin
module.exports = {"commentFormPlaceholder":"_1v_eB","commentBar":"_1zNGT"};